import React from 'react';
import Immutable from 'immutable';

import { Node } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { NodeArticle } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface ProjectsFilteredProps {
  entities: Immutable.List<ImmutableEntity<NodeArticle>>;
}

const ProjectsFiltered: React.FC<ProjectsFilteredProps> = ({ entities }) => (
  <div className="row">
    {
      entities.map((entity) => {
        const id = entity.getIn(['nid', 0, 'value']);
        const uuid = entity.getIn(['uuid', 0, 'value']);
        const langcode = entity.getIn(['langcode', 0, 'value']);
        const key = `${uuid}:${langcode}`;

        return (
          <Node
            key={key}
            id={id}
            entity={entity}
            viewMode="teaser"
            classes="col-12 col-md-6 col-lg-4"
          />
        );
      })
    }
  </div>
);

export default ProjectsFiltered;
